/* Pino — scripts del tema. Sin dependencias. */
(function () {
  'use strict';

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '${{amount_no_decimals_with_comma_separator}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents / 100);

    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var value;
    switch (match[1]) {
      case 'amount': value = delimit(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      default: value = delimit(cents, 0, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  var toastTimer;
  function showToast() {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 9000);
  }
  document.querySelectorAll('[data-toast-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var toast = document.getElementById('CartToast');
      if (toast) toast.hidden = true;
    });
  });

  /* ---------- Formulario contra entrega (Releasit u otra app) ----------
     Busca el botón que la app pone dentro de la zona de compra y lo usa
     para todos los botones de la página (fijo, chat, cierre). */
  function codTrigger() {
    var info = document.querySelector('.product__info');
    if (!info) return null;
    var blocks = info.querySelectorAll('.shopify-app-block, [id^="shopify-block-"]');
    for (var i = 0; i < blocks.length; i++) {
      var el = blocks[i].querySelector('button, a[href], [role="button"]');
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }
  function openOrder() {
    var trigger = codTrigger();
    if (trigger) { trigger.click(); return true; }
    var buy = document.querySelector('[data-buy-now]');
    if (buy && !buy.disabled) { buy.click(); return true; }
    return false;
  }
  document.querySelectorAll('[data-cod-open]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!document.querySelector('[data-product-form]')) return;
      event.preventDefault();
      openOrder();
    });
  });

  /* ---------- Galería ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('.gallery__viewport');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__thumb'));
    if (!viewport || slides.length === 0) return;

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__dot'));
    var counter = gallery.querySelector('[data-gallery-index]');
    function setCurrent(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = index + 1;
    }

    function goTo(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setCurrent(index);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        setCurrent(index);
        ticking = false;
      });
    }, { passive: true });

    gallery.goToMedia = function (mediaId) {
      var index = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (index > -1) goTo(index);
    };
  });

  /* ---------- Formulario de producto ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.elements['quantity'] || root.querySelector('[data-qty-input]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyBtn = root.querySelector('[data-buy-now]');
    var errorEl = root.querySelector('[data-product-error]');
    var gallery = document.querySelector('[data-gallery]');
    var sticky = document.querySelector('[data-sticky-atc]');
    var section = root.closest('section') || document;
    var currentVariant = data.variants.find(function (v) { return v.id === Number(idInput.value); }) || data.variants[0];

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function getQuantity() {
      var bundle = root.querySelector('[data-bundle] input:checked');
      if (bundle) return parseInt(bundle.value, 10) || 1;
      return parseInt(qtyInput.value, 10) || 1;
    }

    function renderPrices() {
      var v = currentVariant;
      if (!v) return;
      section.querySelectorAll('[data-price]').forEach(function (priceEl) {
        var cur = priceEl.querySelector('[data-price-current]');
        var cmp = priceEl.querySelector('[data-price-compare]');
        var badge = priceEl.querySelector('[data-price-badge]');
        if (cur) cur.textContent = formatMoney(v.price, data.moneyFormat);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (cmp) {
          cmp.hidden = !onSale;
          if (onSale) cmp.textContent = formatMoney(v.compare_at_price, data.moneyFormat);
        }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = 'Ahorras ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
      });

      root.querySelectorAll('[data-bundle]').forEach(function (bundle) {
        var qty = parseInt(bundle.querySelector('input').value, 10) || 1;
        var discount = parseInt(bundle.dataset.discount, 10) || 0;
        var total = Math.round(v.price * qty * (100 - discount) / 100);
        // Tachado = precio normal por la misma cantidad: el ahorro que se ve es el real del pack.
        var refTotal = v.price * qty;
        var totalEl = bundle.querySelector('[data-bundle-total]');
        var compareEl = bundle.querySelector('[data-bundle-compare]');
        var unitEl = bundle.querySelector('[data-bundle-unit]');
        if (totalEl) totalEl.textContent = formatMoney(total, data.moneyFormat);
        if (unitEl) unitEl.textContent = formatMoney(Math.round(total / qty), data.moneyFormat) + ' c/u';
        if (compareEl) {
          compareEl.hidden = !(refTotal > total);
          compareEl.textContent = formatMoney(refTotal, data.moneyFormat);
        }
      });

      if (sticky) {
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sp) {
          var checked = root.querySelector('[data-bundle] input:checked');
          var disc = checked ? (parseInt(checked.closest('[data-bundle]').dataset.discount, 10) || 0) : 0;
          sp.textContent = formatMoney(Math.round(v.price * getQuantity() * (100 - disc) / 100), data.moneyFormat);
          var pack = sticky.querySelector('[data-sticky-pack]');
          if (pack) {
            var nameEl = checked && checked.closest('[data-bundle]').querySelector('.bundle__name');
            pack.textContent = nameEl && getQuantity() > 1 ? nameEl.textContent.trim() + ' · ' : '';
          }
        }
      }
    }

    function renderAvailability() {
      var available = currentVariant && currentVariant.available;
      [addBtn, buyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
        btn.textContent = available ? btn.dataset.label : (currentVariant ? 'Agotado' : 'No disponible');
      });
      if (sticky) {
        var sb = sticky.querySelector('button');
        if (sb) sb.disabled = !available;
      }
    }

    function onOptionChange() {
      var opts = selectedOptions();
      currentVariant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (currentVariant) {
        idInput.value = currentVariant.id;
        if (currentVariant.featured_media && gallery && gallery.goToMedia) {
          gallery.goToMedia(currentVariant.featured_media.id);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
      renderPrices();
      renderAvailability();
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', onOptionChange);
    });

    root.querySelectorAll('[data-bundle] input').forEach(function (input) {
      input.addEventListener('change', function () {
        qtyInput.value = input.value;
        renderPrices();
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(1, getQuantity() + parseInt(btn.dataset.qtyChange, 10));
        qtyInput.value = next;
        renderPrices();
      });
    });

    function addToCart() {
      if (errorEl) errorEl.hidden = true;
      qtyInput.value = getQuantity();
      var body = new FormData(form);
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'No pudimos agregar el producto.');
          return json;
        });
      });
    }

    function setLoading(btn, loading) {
      if (!btn) return;
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      btn.disabled = loading;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      if (!addBtn) return;
      event.preventDefault();
      setLoading(addBtn, true);
      addToCart()
        .then(function () {
          return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast();
        })
        .catch(function (err) { showError(err.message); })
        .finally(function () { setLoading(addBtn, false); renderAvailability(); });
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        setLoading(buyBtn, true);
        addToCart()
          .then(function () {
            // Contra entrega: nunca mandamos al pago con tarjeta desde aquí.
            window.location.href = buyBtn.dataset.buyTarget === 'checkout' ? '/checkout' : window.routes.cart_url;
          })
          .catch(function (err) {
            showError(err.message);
            setLoading(buyBtn, false);
            renderAvailability();
          });
      });
    }

    /* Botón fijo en móvil */
    if (sticky) {
      var target = root.querySelector('[data-buy-zone]') || root.querySelector('.product__buttons');
      // Con Releasit el botón está en el bloque de app que sigue a la zona de compra.
      var appBlock = target && target.nextElementSibling;
      if (appBlock && appBlock.matches('.shopify-app-block, [id^="shopify-block-"]')) target = appBlock;
      if (target && 'IntersectionObserver' in window) {
        var footer = document.querySelector('.footer');
        var mainVisible = true;
        var footerVisible = false;
        var update = function () {
          sticky.classList.toggle('is-visible', !mainVisible && !footerVisible);
          sticky.setAttribute('aria-hidden', mainVisible || footerVisible ? 'true' : 'false');
        };
        new IntersectionObserver(function (entries) {
          // Visible desde que entra del anuncio, se esconde solo cuando el botón real está en pantalla.
          mainVisible = entries[0].isIntersecting;
          update();
        }).observe(target);
        if (footer) {
          new IntersectionObserver(function (entries) {
            footerVisible = entries[0].isIntersecting;
            update();
          }).observe(footer);
        }
      }
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (stickyBtn.dataset.action === 'buy') {
            if (!openOrder() && addBtn) addBtn.click();
          } else if (addBtn) {
            addBtn.click();
          } else {
            openOrder();
          }
        });
      }
    }

    renderPrices();
    renderAvailability();
  });

  /* ---------- Hora de Chile ---------- */
  function chileNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var get = function (t) { return parseInt(parts.find(function (p) { return p.type === t; }).value, 10); };
      return new Date(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'));
    } catch (e) {
      return new Date();
    }
  }
  function isWeekday(d) { return d.getDay() !== 0 && d.getDay() !== 6; }

  /* ---------- Hora de corte (despacho hoy) ---------- */
  document.querySelectorAll('[data-cutoff]').forEach(function (el) {
    var hour = parseInt(el.dataset.cutoff, 10);
    var out = el.querySelector('[data-cutoff-left]');
    function tick() {
      var now = chileNow();
      var cut = new Date(now); cut.setHours(hour, 0, 0, 0);
      var diff = cut - now;
      if (!isWeekday(now) || diff <= 0) { el.hidden = true; return; }
      var h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4);
      out.textContent = (h > 0 ? h + ' h ' : '') + m + ' min';
      el.hidden = false;
    }
    tick();
    setInterval(tick, 30000);
  });

  /* ---------- Fecha estimada de entrega ---------- */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    function addBusinessDays(date, days) {
      var d = new Date(date);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (isWeekday(d)) days--;
      }
      return d;
    }
    var min = parseInt(el.dataset.min, 10) || 2;
    var max = Math.max(min, parseInt(el.dataset.max, 10) || 5);
    var cutoff = parseInt(el.dataset.cutoffHour, 10) || 0;
    var start = chileNow();
    // Si hay hora de corte y ya pasó (o es fin de semana), el despacho parte el próximo día hábil.
    if (cutoff > 0 && (!isWeekday(start) || start.getHours() >= cutoff)) {
      start = addBusinessDays(start, 1);
    }
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    var from = addBusinessDays(start, min).toLocaleDateString('es-CL', opts);
    var to = addBusinessDays(start, max).toLocaleDateString('es-CL', opts);
    var target = el.querySelector('[data-delivery-range]');
    if (target) target.textContent = 'entre el ' + from + ' y el ' + to;
  });

  /* ---------- Videos UGC: se reproducen al verlos ---------- */
  document.querySelectorAll('[data-ugc] video').forEach(function (video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduce) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); }
        });
      }, { threshold: 0.6 }).observe(video);
    }
    var btn = video.parentElement.querySelector('[data-ugc-sound]');
    if (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-ugc] video').forEach(function (v) { if (v !== video) v.muted = true; });
        video.muted = !video.muted;
        if (video.paused) video.play().catch(function () {});
        btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
        btn.classList.toggle('is-on', !video.muted);
      });
    }
  });

  /* ---------- Tabla "modo tranqui": interruptor ---------- */
  document.querySelectorAll('[data-mode]').forEach(function (box) {
    var sw = box.querySelector('[data-mode-switch]');
    var hint = box.querySelector('[data-mode-hint]');
    if (!sw) return;
    var touched = false;
    function set(on) {
      box.classList.toggle('is-on', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
    }
    sw.addEventListener('click', function () {
      touched = true;
      set(sw.getAttribute('aria-checked') !== 'true');
      if (hint) hint.hidden = true;
    });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    // Parte apagado y se enciende solo una vez cuando el cliente llega a la tabla.
    set(false);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () { if (!touched) set(true); }, 700);
    }, { threshold: 0.55 });
    io.observe(box);
  });

  /* ---------- Dolor vs modo tranqui: el interruptor se enciende al llegar ---------- */
  document.querySelectorAll('[data-pr]').forEach(function (box) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    box.classList.remove('is-on');
    var sw = box.querySelector('.pr__switch');
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      setTimeout(function () { box.classList.add('is-on'); }, 350);
    }, { threshold: 0.9 });
    io.observe(sw || box);
  });

  /* ---------- Comparativa real: ver todos los puntos en celular ---------- */
  document.querySelectorAll('[data-audit-more]').forEach(function (btn) {
    var table = btn.closest('section').querySelector('[data-audit-table]');
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      var open = table.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Ver menos' : label;
    });
  });

  /* ---------- Dolor en formato chat: los mensajes aparecen al llegar ---------- */
  document.querySelectorAll('.pchat').forEach(function (sec) {
    if (!('IntersectionObserver' in window)) { sec.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      sec.classList.add('is-in');
      io.disconnect();
    }, { threshold: 0.25 });
    io.observe(sec);
  });

  /* ---------- Carrito: actualizar cantidad al cambiar ---------- */
  document.querySelectorAll('[data-cart-form] input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
  document.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.cartQty, 10));
      input.form.submit();
    });
  });

  /* ---------- Orden en colecciones ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
